export default __webpack_public_path__ + "static/media/logo-us-Fabletics.735ea4c0.svg";